export default {
  ticketState: null,
  ticketStates: null,
  ticketStatesMap: {},
  orderStates: null,
  orderStatesMap: {},
};
